module.exports = __webpack_public_path__ + "img/cantoo.4681777.png";